import { createAxiosInstance } from "./index";
import hostConfig from "@/config/hostResolver";

const baseUrl = process.env.VUE_APP_FORM_URL ?? `${hostConfig.apiBaseUrl}/validation-service`;

class ValidationService {
  constructor() {
    this.apiClient = createAxiosInstance(baseUrl);
  }

  getValidationRulesForForm(formId = undefined, params = {}) {
    return this.apiClient
      .get(`${baseUrl}/v2/validation-rule/form/${formId}`, {
        params,
        errorContext: "Failed to load form validation rules",
      })
      .then((r) => {
        return r?.data;
      });
  } // end getValidationRulesForForm
}

export default ValidationService;
